// extracted by mini-css-extract-plugin
export default {"background":"about_background__djyi4","textSpecial":"about_textSpecial__xJKD1","imgSpecial":"about_imgSpecial__ekmhj"};